/** Static /shop/* routes that must remount independently of category browsing. */
const SHOP_FIXED_ROUTE_PREFIXES = ["/shop/designs", "/shop/product"] as const;

/**
 * Keep `ShopProductDirectory` mounted when switching `/shop` ↔ `/shop/:category`.
 * Avoids full remount + skeleton flash on "Shop by product" navigation.
 */
export function resolveShopOutletKey(pathname: string): string {
  if (pathname === "/shop") return "/shop-directory";

  if (
    SHOP_FIXED_ROUTE_PREFIXES.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
    )
  ) {
    return pathname;
  }

  if (/^\/shop\/[^/]+$/.test(pathname)) {
    return "/shop-directory";
  }

  return pathname;
}
